import React, { Component } from 'react';

import { AgGridReact } from "@ag-grid-community/react";
import { Loader } from 'semantic-ui-react';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';

class FundPositionGroupInfoGrid extends Component {

  constructor(props) {
    super(props);

    this.state = {
      columnDefs: props.fundPositionGroupInfoGridColumns,
      defaultColDef: {
        enableCellChangeFlash: true,
        minWidth: 100
      },
      groupDefaultExpanded: 0,
    };
  }

  getRowNodeId = data => {
    return data.id;
  };

  onGridReady = params => {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;
    this.gridApi.closeToolPanel();
    this.props.fundPositionGroupInfoGridToProps(params);
  };

  render() {
    const {
        listFundPosGroupInfoActionStatus,
        listFundPosGroupInfoActionResp,
    } = this.props;

    const isLoading = listFundPosGroupInfoActionStatus === ACTION_STATUS.LOGINING;
    let listFundPosGroupInfoArray = [];
    if(!!listFundPosGroupInfoActionResp && !!listFundPosGroupInfoActionResp.data) {
        listFundPosGroupInfoArray = listFundPosGroupInfoActionResp.data;
    }


    return (
      <div className={'ag-theme-balham grid-wrapper'}>
        {isLoading ? (
            <Loader active content="Loading..." />
          ) : (
          <AgGridReact
            // properties
            columnDefs={this.state.columnDefs}
            rowData={listFundPosGroupInfoArray}
            defaultColDef={this.state.defaultColDef}
            rowSelection={this.state.rowSelection}
            rowClassRules={this.state.rowClassRules}
            enableSorting={true}
            enableFilter={true}
            animateRows={true}
            deltaRowDataMode={false}
            enableColResize={true}
            resizable={true}
            sideBar={true}
            getRowNodeId={this.getRowNodeId}
            // events
            onGridReady={this.onGridReady}
          />
        )}
      </div>
    );
  }
}

export default FundPositionGroupInfoGrid;